var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Field',{attrs:{"name":_vm.name,"reactions":_vm.reactions,"disabled":_vm.disabled,"required":_vm.required,"validator":_vm.validator,"decorator":[_vm.FormItem],"component":[_vm.component, _vm.componentProps]}})}
var staticRenderFns = []

export { render, staticRenderFns }